'use client';

import { useTranslations } from 'next-intl';
import type { EditableNavigationMenuItemProps } from '../../../NavigationMenu/components/NavigationMenuItem/types';
import { NavigationMenu } from '../../../NavigationMenu/NavigationMenu';

type AccountReviewSectionProps = {
  namespace: string;
  className?: string;
  accountReviewReminder?: string;
  accountReviewReminderInterval?: string;
  onEdit: () => void;
};

function AccountReviewSection({ namespace, className, accountReviewReminder, accountReviewReminderInterval, onEdit }: AccountReviewSectionProps) {
  const t = useTranslations(namespace);

  const accountReviewReminderItems: EditableNavigationMenuItemProps[] = [
    {
      label: t('account_review_reminder'),
      data: accountReviewReminder ?? '',
      buttonText: t('edit'),
      chevron: false,
      onClick: onEdit,
      variant: 'editable',
      'data-testid': 'account-review-reminder-edit-section',
      'button-data-testid': 'account-review-reminder-edit-section-button',
      displayedValueTestId: 'account-review-reminder-displayed-value',
      dataInterval: accountReviewReminderInterval,
    },
  ];

  return <NavigationMenu variant="secondary" items={accountReviewReminderItems} className={className} />;
}

export { AccountReviewSection };
